
import { Vue, Component, Prop } from "vue-property-decorator";

// import UiButton from "@/components/button/ui-button.vue";
import UiButtonTest from "@/components/button/ui-button.vue";
import ContractorInvite from "@/components/contractors/ContractorInviteNew.vue";
import { Payment_Card } from "@/generated/graphql";
import AddSubscription from "@/views/manage//Modal/add-subcription-modal-resource.vue";
import GET_SUBSCRIPTIONS_DETAILS from "@/apollo/payment/GetSubscriptionsDetails.gql";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import { User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import getActiveManagersCountCondition from "@/helpers/queryConditions/getActiveManagersCountCondition";
import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";
import { Subscription } from "@/generated/graphql";

interface SubscriptionDetails {
  subscriptionPlans: SubscriptionPlan[];
  currentSubscription: Subscription;
  activeManagersCount: number;
  paymentCardId?: string;
}

@Component({
  components: {
    UiButtonTest,
    ContractorInvite,
    PlusIcon,
    AddSubscription,
  },
  apollo: {
    subscriptionDetails: {
      query: GET_SUBSCRIPTIONS_DETAILS,
      variables() {
       return {
          companyId: this.companyId,
          userId: this.currentUserId,
          activeManagersCountCondition: getActiveManagersCountCondition(
            this.companyId
          ),
        };
      },
      update: (data): SubscriptionDetails => {
        return {
          subscriptionPlans: data.subscription_plan,
          currentSubscription: data.subscription[0],
          activeManagersCount: data.activeManagersCount.aggregate.count,
          paymentCardId: data.payment_card[0]?.id,
        };
      },
    },
  },
})
export default class InvitationModalWithButton extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
 @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true })
  readonly companyBusinessName!: string;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: "Invite Resources" })
  readonly actionButtonContent!: string;
  // @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;

  contractorDialog: boolean = false;
  showSubscriptionDialog: boolean = false;
  paymentCards: Payment_Card[] = [];
  subscriptionDetails: SubscriptionDetails | null = null;

  get currentSubscription(): Subscription {
    return this.subscriptionDetails.currentSubscription;
  }

 get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER;
  }

  get freeTrialExpiry(): boolean {
    if (this.subscriptionDetails.currentSubscription) {
      const periodEndTime =
        this.subscriptionDetails.currentSubscription.current_period_end;
      const formattedEndDate = new Date(periodEndTime * 1000);

      const startDate = new Date(
        this.subscriptionDetails.currentSubscription.created_at
      );

      // Format dates into localized date strings
      const dateFormatter = new Intl.DateTimeFormat("en-US", {
        month: "long", // Full month name (e.g., "April")
        day: "numeric", // Day of the month (e.g., "21")
        year: "numeric", // Full year (e.g., "2022")
      });

      // Format the date using the dateFormatter
      const formattedEndDateStr = dateFormatter.format(formattedEndDate);
      const formattedStartDateStr = dateFormatter.format(startDate);

      const differenceMs = formattedEndDate.getTime() - startDate.getTime();

      const differenceDays = differenceMs / (1000 * 60 * 60 * 24);
      return Math.floor(differenceDays) > 7;
    }
  }

  handleInviteClick() {
    this.contractorDialog = true;
  }

  get noCompany(): boolean {
    return !this.companyId;
  }
}
